import React from "react";
import NumTrapsHauled from "../../components/NumTrapsHauled/NumTrapsHauled";
import NumTrapsInWater from "../../components/NumTrapsInWater/NumTrapsInWater";
import NumTrapsPerString from "../../components/NumTrapsPerString/NumTrapsPerString";
import NumBuoyLines from "../../components/NumBuoyLines/NumBuoyLines";
import StringsHauled from "../../components/StringsHauled/StringsHauled";
import AvgSoakTime from "../../components/AvgSoakTime/AvgSoakTime";

function EffortForm5(props) {
  if (props.currentStep !== 4) {
    return null;
  }

  return (
    <div className="margAll10">
      {props.displayTrapsInWaterQuestion && (
        <NumTrapsInWater
          numTrapsInWater={props.numTrapsInWater}
          handleChange={props.handleChange}
        />
      )}

      {props.displayLinesInWaterQuestion && (
        <NumBuoyLines
          numBuoyLines={props.numBuoyLines}
          handleChange={props.handleChange}
        />
      )}

      {props.displayTrapsPerEffortQuestion && (
        <NumTrapsHauled
          numTrapsHauled={props.numTrapsHauled}
          handleChange={props.handleChange}
        />
      )}

      {props.displayStringsHauledPerEffortQuestion && (
        <StringsHauled
          stringsHauled={props.stringsHauled}
          handleChange={props.handleChange}
        />
      )}

      {props.displayTrapsPerStringQuestion && (
        <NumTrapsPerString
          numTrapsPerString={props.numTrapsPerString}
          handleChange={props.handleChange}
        />
      )}

      {props.displayAverageSoakTimePerEffortQuestion && (
        <AvgSoakTime
          avgSoakTime={props.avgSoakTime}
          handleChange={props.handleChange}
        />
      )}
    </div>
  );
}

export default EffortForm5;
